import lottie from 'lottie-web';

'use strict';
import $ from 'jquery';

export default class OntraLottie {
    static init() {
        $('[data-lottie-file').each((index, el) => {
            new OntraLottie($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        let $target = this.el.data('lottie-target');
        // lottieResize($target);

        // $(window).on('resize', function () {
        //     lottieResize($target);
        // });

        let lottie_path = this.el.data('lottie-file');
        let animation = lottie.loadAnimation({
            container: document.getElementById(this.el.data('lottie-target')), // Required
            path: lottie_path, // Required
            renderer: 'svg', // Required
            loop: true === this.el.data('lottie-loop'), // Optional
            autoplay: true, // Optional
        });
        this.el.trigger('lottie-playing');
    }
}
